// Changelog API — log změn aplikace (veřejný, bez přihlášení)
import { api } from './client'

export const changelogApi = {
  // [{ date: 'YYYY-MM-DD', items: [{ type: 'new'|'improved'|'fixed'|'other', text }] }], nejnovější první
  getChangelog: () => api.get('/changelog'),
}
